import { render, staticRenderFns } from "./groups-2-add-to-group-dialog-content.vue?vue&type=template&id=65390980&"
import script from "./groups-2-add-to-group-dialog-content.vue?vue&type=script&lang=ts&"
export * from "./groups-2-add-to-group-dialog-content.vue?vue&type=script&lang=ts&"
import style0 from "./groups-2-add-to-group-dialog-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VContainer,VForm,VIcon,VSelect,VSpacer,VTextField,VToolbarTitle})
